import { DisplayPosition } from '@/type/display-position';
import { makeRequest } from '@/common/manager/request';
import { useEffect, useState } from 'react';
import { getStepRequestConfigSetterSnippet, getStepShapeSetterSnippet, } from '@/common/manager/setter-snippet';
import { dataOriginRequest } from '@/common/util/const';
import { filterHiddenStep } from '@/components/cn-step/util';
import { executeFunction, getRealResponse, isArrayNotEmpty, isEmptyButNotZero, isRequestConfig, } from '@/common/util/util';
import isPlainObject from 'lodash/isPlainObject';
import { CnStep as UICnStep, CnStepItem } from '@cainiaofe/cn-ui-m';
import { _getContext } from '@/common/util/biz-component-prop-name';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
    ],
    title: '步骤',
    componentName: 'CnStep',
    formComponent: (props) => {
        const _context = executeFunction(props?._getContext) || {};
        const { steps: propSteps, requestConfig, dataOrigin, stepStyle } = props;
        let initialSteps = filterHiddenStep(propSteps, _context?.state);
        if (dataOrigin === dataOriginRequest) {
            initialSteps = [];
        }
        const [steps, setSteps] = useState(initialSteps);
        const [current, setCurrent] = useState();
        useEffect(() => {
            if (dataOrigin !== dataOriginRequest) {
                setSteps(filterHiddenStep(propSteps, _context?.state));
            }
        }, [propSteps]);
        useEffect(() => {
            if (dataOrigin === 'request') {
                let realSteps;
                let realCurrent;
                if (isRequestConfig(requestConfig)) {
                    makeRequest({
                        buttonConfig: {
                            options: {
                                requestConfig,
                            },
                        },
                        recordDataSource: {},
                        state: _context?.state || {},
                        needSuccessToast: false,
                    })
                        .then((res) => {
                        const res2 = getRealResponse(res);
                        const { success, data } = res2;
                        if (success) {
                            if (isPlainObject(data)) {
                                const { list: originList, activeKey: originalActiveKey } = data;
                                const list = filterHiddenStep(originList, _context);
                                if (isArrayNotEmpty(list)) {
                                    let tempCurrent;
                                    const newList = [];
                                    if (typeof originalActiveKey === 'number') {
                                        tempCurrent = originalActiveKey;
                                    }
                                    for (const index in list) {
                                        const { label, value, title, key } = list[index];
                                        if (value || key) {
                                            if (typeof originalActiveKey === 'string' &&
                                                originalActiveKey === value) {
                                                tempCurrent = +index;
                                            }
                                            const temp = {
                                                ...list[index],
                                                title: label,
                                                key: value || key,
                                            };
                                            if (title) {
                                                temp.title = title;
                                            }
                                            newList.push(temp);
                                        }
                                    }
                                    if (isEmptyButNotZero(tempCurrent)) {
                                        tempCurrent = 0;
                                    }
                                    realSteps = newList;
                                    realCurrent = tempCurrent;
                                }
                            }
                        }
                    })
                        .finally(() => {
                        setSteps(realSteps);
                        setCurrent(realCurrent);
                    });
                }
            }
        }, []);
        const handleStep = (steps) => {
            const result = [];
            if (Array.isArray(steps) && steps.length > 0) {
                steps.forEach((item, index) => {
                    const { title, content, key, ...rest } = item;
                    if (key) {
                        result.push(React.createElement(CnStepItem, { ...rest, key: index, title: title, content: content }));
                    }
                });
            }
            return result;
        };
        const stepProps = {
            ...stepStyle,
            current,
        };
        return React.createElement(UICnStep, { ...stepProps }, handleStep(steps));
    },
    getDefaultProps: () => {
        return {
            dataOrigin: dataOriginRequest,
        };
    },
    getPrototypeList: () => {
        return [
            getStepRequestConfigSetterSnippet(),
            {
                name: 'stepStyle',
                title: '步骤条样式',
                setter: {
                    componentName: 'ObjectSetter',
                    props: {
                        config: {
                            items: [
                                getStepShapeSetterSnippet(),
                                {
                                    name: 'direction',
                                    title: '步骤条的展示方向',
                                    setter: {
                                        componentName: 'RadioGroupSetter',
                                        props: {
                                            options: [
                                                {
                                                    title: '水平排列',
                                                    value: 'hoz',
                                                },
                                                {
                                                    title: '竖直排列',
                                                    value: 'ver',
                                                },
                                            ],
                                        },
                                    },
                                },
                            ],
                        },
                    },
                },
            },
        ];
    },
    formItemBeforeHandler: (formItem, config) => {
        const componentProps = formItem['x-component-props'];
        if (componentProps) {
            componentProps[_getContext] = () => {
                return config?._context;
            };
        }
    },
};
